<div class="container-fluid">
    <div class="row">
        <div class="col-lg-12">
            <div class="card m-b-30">
                <div class="card-body">
                    <form #appointmentForm="ngForm" name="appointmentForm">

                        <div class="row">
                            <div class="col-lg-12">
                                <div class="card m-b-30">
                                    <div class="card-body">
                                        <div>
                                            <h5><a href="javascript:void(0)"><i class="fa fa-arrow-circle-left"
                                                        (click)="getback()"> BACK</i></a>
                                            </h5>
                                        </div>
                                        <!-- SEARCH PATIENT STARTS -->

                                        <form [formGroup]="create_med_sub_cate_form">
                                            <div class="row">
                                                <div class="col-12">
                                                    <h6 class="text-center">ADD SUB-CATEGORY</h6>
                                                </div>
                                            </div><br>
                                            <div class="row">

                                                <div class="col-lg-4 col-md-4 "></div>
                                                <div class="col-lg-4 col-md-4 ">
                                                    <div class="text-dark">Select Category</div>
                                                    <select class="form-control select" formControlName="med_cate_id"
                                                        (change)="retriveSubcategory($event)">

                                                        <option *ngFor="let x of cate" [value]="x.med_cate_id">
                                                            {{ x.med_cate}}
                                                        </option>

                                                    </select>


                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            </div>
                                            <br>
                                            <div class="row">

                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12">
                                                    <div class="text-dark">Enter Sub Category Name</div>
                                                    <input type="text" formControlName="med_sub_cate"
                                                        placeholder="Sub-Category Name" class="form-control select" />
                                                </div>
                                                <div *ngIf="create_med_sub_cate_form.get('med_sub_cate').hasError('required')"
                                                    class="invalid-feedback ml-1">
                                                    Sub-Category Name is <strong>required</strong>.
                                                </div>
                                                <div class="col-lg-4 col-md-4 col-sm-12 col-xs-12"></div>
                                            </div>
                                            <br>
                                            <div class="row">
                                                <div class="col-12 text-center">
                                                    <button type="submit" (click)="createmedicinesubcategory()"
                                                        [disabled]="create_med_sub_cate_form.invalid"
                                                        class="btn btn-primary text-white btn-rounded">SAVE SUB-CATEGORY
                                                    </button>
                                                </div>
                                            </div><br /><br />



                                        </form>

                                        <!-- SEARCH PATIENT ENDS -->

                                        <div class="container-fluid" *ngIf="subcate?.length">
                                            <div class="row">
                                                <div class="col-lg-12">
                                                    <div class="card m-b-30">
                                                        <div class="card-body table-responsive">
                                                            <div class="col-md-12 detail-tbl">
                                                                <table class="table">
                                                                    <thead>
                                                                        <tr>
                                                                            <th scope="col" class="th-item"
                                                                                style="vertical-align: middle">SUB
                                                                                CATEGORY NAME
                                                                            </th>
                                                                            <th scope="col" class="th-item">DELETE</th>
                                                                            <th scope="col" class="th-item">EDIT</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tr *ngFor="let p of subcate let i = index">
                                                                        <td
                                                                            class="font-size-15 text-color align-middle">
                                                                            {{ p?.med_sub_cate}}
                                                                        </td>
                                                                        <!-- <td class="align-middle">
                                                                            <span
                                                                                class="custom-control custom-switch d-inline-block">
                                                                                <input type="checkbox"
                                                                                    class="custom-control-input cursor"
                                                                                    [checked]="p?.cate_status"
                                                                                    (change)="onAccStatusChange(p?.med_cate_id, p?.cate_status,p?.med_cate)"
                                                                                    [id]="i" />
                                                                                <label class="custom-control-label cursor"
                                                                                    [for]="i"></label>
                                                                            </span>
                                                                        </td> -->
                                                                        <td class="align-middle">
                                                                            <div class="d-flex">
                                                                                <i class="fa fa-trash fa-2x" (click)="onAccStatusChange(p?.med_sub_cate_id
                                                                            , p?.subcate_status,p?.med_sub_cate)"></i>


                                                                                <!-- <button type="button"
                                                                                    class="btn btn-primary btn-model"
                                                                                    (click)="onAccStatusChange(p?.med_sub_cate_id
                                                                                    , p?.subcate_status,p?.med_sub_cate)">
                                                                                    DELETE
                                                                                </button> -->
                                                                            </div>
                                                                        </td>

                                                                        <td class="align-middle">
                                                                            <div class="d-flex">
                                                                                <i class="fa fa-pencil fa-2x" (click)="showeditmedsubcate(p?.med_cate_id, p?.med_sub_cate_id, p?.med_sub_cate
                                                                                    , p?.subcate_status)"></i>

                                                                                <!-- <button type=" button"
                                                                                    class="btn btn-primary btn-model"
                                                                                    routerLink="/superadmin/pat-detail/{{ p.pid }}">
                                                                                    EDIT
                                                                                    </button> -->
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                    <tbody>
                                                                        <tr></tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>

                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>



                                    </div>

                                </div>

                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>

<ng-template #showeditmedsubcateModal let-modal>

    <div class="container-fluid ">
        <div style="text-align:right;"> <br /><a data-dismiss="modal" href="javascript:void(0);" class="fa fa-close"
                (click)="modal.dismiss()" style="font-size:18px;color:red;"></a>
        </div>
        <h4>&nbsp;&nbsp;Edit Sub Category&nbsp;&nbsp;</h4>
        <form [formGroup]="editmedsubcateform">

            <div class="row cust_row" align="center">
                <div class="col-sm-12">
                    <div class="col-8 col-sm-10 col-md-8 m-m">
                        <div class="text-dark">Select Category</div>
                        <select class="form-control select" formControlName="med_cate_id">
                            <option value="med_cate_id">{{med_cate}}</option>
                            <option *ngFor="let x of cate" [value]="x.med_cate_id">
                                {{ x.med_cate}}
                            </option>
                        </select>

                    </div>
                </div>
            </div>

            <div class="row cust_row" align="center">
                <div class="col-sm-12">
                    <div class="col-8 col-sm-10 col-md-8 m-m">
                        <input formControlName="med_sub_cate" value="med_sub_cate" type="text" class="form-control">
                        <input formControlName="med_sub_cate_id" value="med_sub_cate_id" type="hidden"
                            class="form-control">
                        <input formControlName="sub_cate_status" value="med_sub_cate_status" type="hidden"
                            class="form-control">

                    </div>
                </div>
            </div>

            <div class="row ">
                <div class="col-md-12" align="center">
                    <button type="button" class="btn btn-primary pl-5 pr-5 mr-2 btn-rounded"
                        (click)="updatesubcate()">Update
                    </button>
                </div>
            </div> <br /><br />
        </form>
    </div>

</ng-template>
<!--end container-->